import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import carImg from 'images/tmp_car_image.png'
import sketch1 from 'images/tmp_car_sketch1.png'
import sketch2 from 'images/tmp_car_sketch2.png'
import DetailTip from 'views/mydata/common/DetailTip'

const CarDetail1 = () => {

	const App = useApp()
	const [tabList, setTabList] = useState(0)
	const [detailTip, setDetailTip] = useState(false)

	const openDetail = () => {
		setDetailTip(true)
	}

	const closeDetail = () => {
		setDetailTip(false)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="shadow">
				<div className="padding center-cont">
					<div className="img-box" style={{ width: "21rem", height: "10rem" }}>
						<img src={carImg} alt="" />
					</div>
					<div className="car-info mt_20">
						<div>
							<span>테슬라</span>
							<span>테슬라 모델X</span>
						</div>
						<p>조대리님 미래 2058년의 차 테슬라 모델X</p>
					</div>
				</div>
			</div>

			<div className="padding">
				<ul className="tab-round">
					<li onClick={() => setTabList(0)} className={tabList === 0 ? "active" : ""}>기본정보</li>
					<li onClick={() => setTabList(1)} className={tabList === 1 ? "active" : ""}>치수정보</li>
				</ul>

				{/* 기본정보 탭 */}
				<h3 className="mt_40">일반</h3>
				<ul className="list-item mt_30">
					<li>
						<span>연식</span>
						<span>2018</span>
					</li>
					<li>
						<span>최초 등록일</span>
						<span>2020.01.01</span>
					</li>
					<li>
						<span>연비</span>
						<span>9.7km/l</span>
					</li>
					<li>
						<span>주행거리<i className="icon icon_question ml_10" onClick={openDetail} /></span>
						<span>0km</span>
					</li>
					<li>
						<span>색상</span>
						<span>흰색</span>
					</li>
					<li>
						<span>차종</span>
						<span>-</span>
					</li>
					<li>
						<span>승차인원</span>
						<span>6인</span>
					</li>
					<li>
						<span>차고지</span>
						<span>서울특별시 영등포구</span>
					</li>
					<li>
						<span>차대번호</span>
						<span>KD1515151D444D410<i className="icon icon_copy ml_10" /></span>
					</li>
				</ul>
				<hr className="my_40" />

				<h3 className="mt_40">엔진</h3>
				<ul className="list-item mt_30">
					<li>
						<span>연료</span>
						<span>디젤</span>
					</li>
					<li>
						<span>배기량</span>
						<span>2,987cc</span>
					</li>
					<li>
						<span>최고출력</span>
						<span>-</span>
					</li>
					<li>
						<span>최대토크</span>
						<span>-</span>
					</li>
				</ul>
				<hr className="my_40" />

				<h3 className="mt_40">새시</h3>
				<ul className="list-item mt_30">
					<li>
						<span>구동방식</span>
						<span>전륜구동</span>
					</li>
					<li>
						<span>변속기</span>
						<span>자동6단</span>
					</li>
				</ul>

				{/* 치수정보 탭 */}
				<div className="car-length mt_30">
					<div className="flex--item_2 mr_20">
						<div className="img-box">
							<img src={sketch1} alt="" />
						</div>
						<div className="length-name">
							<span>전장</span>
						</div>
					</div>
					<div className="flex--item_1">
						<div className="img-box">
							<img src={sketch2} alt="" />
						</div>
						<div className="length-name">
							<span>전폭</span>
						</div>
					</div>
				</div>
				<ul className="list-item mt_50">
					<li>
						<span>전장</span>
						<span>4,295mm</span>
					</li>
					<li>
						<span>전폭</span>
						<span>1,820mm</span>
					</li>
					<li>
						<span>전고</span>
						<span>1,600mm</span>
					</li>
					<li>
						<span>축간거리</span>
						<span>2,670mm</span>
					</li>
					<li>
						<span>윤거전</span>
						<span>-</span>
					</li>
					<li>
						<span>윤거후</span>
						<span>-</span>
					</li>
					<li>
						<span>공차중량</span>
						<span>1,710kg</span>
					</li>
					<li>
						<span>전륜타이어</span>
						<span>225mm/45R/19inck</span>
					</li>
					<li>
						<span>후륜타이어</span>
						<span>225mm/45R/19inck</span>
					</li>
				</ul>
			</div>

			<DetailTip title="주행거리" show={detailTip} closeLayer={closeDetail} content="주행거리의 경우 자동차등록원부에 노출되는 주행거리를 기준으로 표시되어 실제와 다를 수 있으니 참고 부탁드려요." />
		</div>
	)
}

export default CarDetail1